import { useLoadingAnimation } from '@/components/LoadingAnimation/useLoadingAnimation.hook';
import { DEFAULT_ERROR_MESSAGE } from '@/config/text.const';
import { useSaveFileLocally } from '@/hooks/useSaveFileLocally.hook';
import { HttpStatusCode } from '@/services/http/HttpStatusCodes';
import { bulkClUpdateClient } from '@/services/http/clients/bulkClUpdateClient';
import { notificationService } from '@/services/notification/notification.client';

export function useDownloadTemplateFile() {
  const { toggleLoadingAnimation } = useLoadingAnimation();
  const { saveFileLocally, getFileNameFromContentDisposition } = useSaveFileLocally();
  const tempateFileId = '00000000-0000-0000-0000-000000000001';

  const downloadTemplateFile = async () => {
    toggleLoadingAnimation(true);

    try {
      const requestUrl = '/DownloadDocumentFunction';
      const response = await bulkClUpdateClient.get(requestUrl, {
        responseType: 'arraybuffer',
        params: {
          documentId: tempateFileId,
        },
      });
      if (response?.status === HttpStatusCode.OK) {
        const blob = new Blob([response.data]);
        const fileName = getFileNameFromContentDisposition(response.headers['content-disposition']);
        saveFileLocally(blob, fileName);
      }
    }
    catch (err: any) {
      notificationService.open({
        title: 'Error',
        text: err?.message ?? DEFAULT_ERROR_MESSAGE,
        type: 'danger'
      });
    }
    finally {
      toggleLoadingAnimation(false);
    }
  };

  return {
    downloadTemplateFile
  } as const;
}
